import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Type } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { FieldWrapper, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FieldWrapperProps } from '../../wrappers/field-wrapper/field-wrapper.component';

export interface GroupWrapperProps extends FieldWrapperProps {
  showHorizontalLine?: boolean;
}

export interface GroupWrapperFieldConfig extends FormlyFieldConfig<GroupWrapperProps> {
  wrappers?: ['group-wrapper' | Type<GroupWrapperComponent>];
}

@Component({
  selector: 'lib-formly-group-wrapper',
  templateUrl: './group-wrapper.component.html',
  styleUrl: './group-wrapper.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslocoDirective, NgClass, FormlyModule]
})
export class GroupWrapperComponent extends FieldWrapper<GroupWrapperFieldConfig> {}
